import { useState } from 'react';
import { auth } from '../firebase';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getRewardTerms } from '../utils/loyalty';

const MENSAJES_FALLO = {
  INSUFFICIENT_POINTS: (pts) => `Te faltan ${pts} puntos para este beneficio.`,
  OUT_OF_STOCK: () => 'Este beneficio ya no tiene disponibilidad.',
  EXPIRED_REWARD: () => 'Este beneficio ya no está vigente.',
  REWARD_INACTIVE: () => 'Este beneficio no está disponible.',
  REWARD_NOT_FOUND: () => 'No encontramos el beneficio seleccionado.',
  IDENTITY_REQUIRED: () => 'Necesitamos verificar tu identidad antes de usar tus puntos.',
  LIMIT_REACHED: () => 'Ya alcanzaste el límite de canjes para este beneficio.',
  DUPLICATE_REQUEST: () => 'Esta solicitud ya fue procesada. Si no ves el voucher, recargá la página.',
  UNAUTHORIZED: () => 'Debés iniciar sesión para canjear.',
};

function mensajeFallo(code, userPoints, puntosRequeridos) {
  if (code === 'INSUFFICIENT_POINTS') {
    return MENSAJES_FALLO.INSUFFICIENT_POINTS(Math.max(0, (puntosRequeridos || 0) - (userPoints || 0)));
  }
  return MENSAJES_FALLO[code] ? MENSAJES_FALLO[code]() : 'No se pudo completar el canje. Intentá de nuevo.';
}

const nuevoKey = () => `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
const canjearBeneficioFn = httpsCallable(getFunctions(undefined, 'us-central1'), 'canjearBeneficio');

export default function useRedeemBenefit({ userPoints, refreshUserProfile, onNeedLogin }) {
  const [selected, setSelected] = useState(null);
  const [open, setOpen] = useState(false);
  const [voucher, setVoucher] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [key, setKey] = useState(nuevoKey);

  const start = (reward) => {
    if (onNeedLogin) {
      onNeedLogin();
      return;
    }
    setSelected(reward);
    setOpen(true);
    setError('');
    setKey(nuevoKey());
  };

  const confirm = async () => {
    if (busy || !selected) return;
    setBusy(true);
    setError('');
    const user = auth.currentUser;
    if (!user) {
      setError(mensajeFallo('UNAUTHORIZED'));
      setBusy(false);
      return;
    }
    try {
      const result = await canjearBeneficioFn({ premioId: selected.id, idempotencyKey: key });
      const { puntos, plata } = getRewardTerms(selected);
      const vigenciaDias = Number(selected.vigenciaDias || 30);
      setVoucher({
        code: result.data.code,
        rewardName: selected.nombre,
        pointsCost: puntos,
        plata,
        expiresAt: new Date(Date.now() + vigenciaDias * 24 * 60 * 60 * 1000),
      });
      setOpen(false);
      if (refreshUserProfile) refreshUserProfile();
    } catch (err) {
      const { puntos } = getRewardTerms(selected);
      setError(mensajeFallo(err.message || '', userPoints, puntos));
    } finally {
      setBusy(false);
      setKey(nuevoKey());
    }
  };

  return { selected, open, setOpen, voucher, setVoucher, error, busy, start, confirm };
}
